<template>
  <div v-if="!isIEBrowser" class="container">
    <div class="btn_download text-center" @click="capture()">
      <div class="download-button">
        <i class="fa fa-download" aria-hidden="true" style="color: #05174d; font-size: 14px; margin-right: 0px"></i>
        &nbsp;<span>{{ lang['hotel_mobile_new'].SFS_LANG_ROW_62 }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import '@/assets/scss/modules/ButtonDownloadVoucher.scss'
import html2canvas from 'html2canvas'

export default {
  name: 'ButtonDownloadVoucher',
  props: {
    nameVoucher: {
      type: String,
      default: ''
    },
    canDownload: {
      type: Boolean
    }
  },
  data() {
    return {
      isIEBrowser:
        navigator.userAgent.indexOf('MSIE ') > -1 ||
        navigator.userAgent.indexOf('Trident/') > -1 ||
        navigator.userAgent.indexOf('Edge/') > -1
    }
  },
  methods: {
    capture: function () {
      if (this.canDownload) {
        html2canvas(document.querySelector('#app'), {
          useCORS: true,
          logging: false,
          x: 0,
          y: 0
        }).then((canvas) => {
          let dataUrl = canvas.toDataURL('image/png')
          let a = document.createElement('a')
          a.href = dataUrl
          a.download = this.nameVoucher + '_Voucher.png'
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
        })
      }
    }
  }
}
</script>
